import { useSWRInfinite } from 'swr';
import app from '../base';

const useVehicles = (search, limit = 20, options = {}) => {
  const { data, error, mutate, size, setSize } = useSWRInfinite(
    (index) => {
      const params = new URLSearchParams();
      params.set('limit', limit || 20);
      params.set('page', index ? Number(index) + 1 : 1);
      if (search) params.set('search', search);
      if (options?.hmsId) params.set('hmsId', options.hmsId);
      if (options?.status) params.set('verificationStatus', options.status);
      if (options?.duration) params.set('duration', options.duration);
      if (options?.source) params.set('source', options.source);
      if (options?.reasons) params.set('reasons', options.reasons);

      return `/vehicles?${params.toString()}`;
    },
    undefined,
    app.auth().currentUser.uid
  );

  return {
    data,
    isLoading: !error && !data,
    isLoadingMore: (!error && !data) || (size > 0 && data && typeof data[size - 1] === 'undefined'),
    isError: error,
    mutateVehicles: mutate,
    size,
    setSize
  };
};

export default useVehicles;
